import React, { useEffect } from "react";
import CheckoutItem from "../../Components/CheckoutItem";
import CheckoutForm from "../../Components/CheckoutForm";
import { XMarkIcon } from "@heroicons/react/24/solid";
import useCheckout from "./useCheckout";
import { Elements } from "@stripe/react-stripe-js";
import { stripeAPIKey } from "../../Constant/Data";
import { loadStripe } from "@stripe/stripe-js";

export default function CheckoutDrawer({ 
  isOpen,
   onClose,  
    handelModalType,
   }) {
  const {
    itemDetail,
    subTotal,
    discountPrice,
    serviceCharges,
    total,
    userData,

  } = useCheckout();
 useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const stripePromise=loadStripe(stripeAPIKey)
//   if (!isOpen){
// return null
//   }
  return (
  <Elements stripe={stripePromise}>
      <div className={`${isOpen?"fixed":""} inset-0 z-50 ${!isOpen&& "hidden"} `}>
      {/* Overlay */}
      {isOpen && (
        <div
          className="absolute  inset-0 bg-black bg-opacity-30 transition-opacity duration-300"
          onClick={onClose}
        />
      )}

      {/* Right Drawer with Slide Animation */}
 {/* { isOpen&& */}
   <div
        className={`absolute top-0 pb-4  right-0 h-full w-full sm:max-w-xl bg-blueGray border-l border-borderGray shadow-xl overflow-y-auto text-white transition-transform duration-500 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-borderGray">
          <h2 className="text-lg font-semibold text-white">Checkout</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1 rounded-full hover:bg-gray-700">
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4">
          {/* Subscription Details */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Subscription</h4>
            <div className="space-y-6 border-b pb-4 border-borderGray">
              <CheckoutItem {...itemDetail} />
            </div>
            <div className="mt-6 text-sm space-y-2 border-b pb-6 border-borderGray">
              <div className="flex justify-between mb-2">
                <span className="text-gray-300">Subtotal</span>
                <span className="font-medium text-white">${subTotal}</span>
              </div>
              {/* <div className="flex justify-between mb-2">
                <span className="text-gray-300">Discount</span>
                <span className="font-medium text-white">${discountPrice}</span>
              </div> */}
              <div className="flex justify-between">
                <span className="text-gray-300">Tax Charges</span>
                <span className="font-medium text-white">${serviceCharges}</span>
              </div>
            </div>
            <div className="mt-4 text-lg flex justify-between font-bold">
              <span className="text-white">Total</span>
              <span className="text-primaryBlue">${total}</span>
            </div>
          </div>

          {/* User Info */}
          <div className="border border-borderGray rounded p-4 bg-[#384355]">
            <div className="flex">
              <span className="font-medium w-32 text-white">Name</span>
              <span className="text-gray-300">{userData?.name}</span>
            </div>
          </div>

          {/* Payment Section */}
          <div className="border border-borderGray rounded p-4 bg-[#384355]">
            <div className="mb-4">
              <img
                src="https://leadershipmemphis.org/wp-content/uploads/2020/08/780370.png"
                className="h-6"
                alt="Payment"
              />
            </div>
            <CheckoutForm
             handelModalType={handelModalType}
              amount={total}
              id={itemDetail?._id}
              onClose={onClose}
            />
          </div>
        </div>
      </div>
      {/* } */}
    </div>
  </Elements>
  );
}
